import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

const ReceiversSkeleton = () => (
    <ul className="receivers__list-skeleton">
        {Array.from(Array(10)).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index} className="receivers__list-item receivers__list-item--skeleton">
                <DarkSkeleton
                    className="receivers__receiver-name receivers--skeleton"
                    height={16}
                    width={index % 2 === 0 ? '60%' : '90%'}
                />
                <DarkSkeleton className="receivers__account-number receivers--skeleton" height={14} width="40%" />
            </li>
        ))}
    </ul>
);
export default ReceiversSkeleton;
